/**
 * Test data backing the Autogenerate button on the plantilla post form.
 *
 * Fills every required field so the primary action enables on the first try. Keep it in
 * lockstep with the form: a new required field must be added here in the same change, or
 * Autogenerate silently stops working.
 *
 * The two foreign keys — the catalog title and the unit — are NOT here. They are resolved
 * against the options the form has already loaded, because an id this module invented would
 * fail the server's "it must exist and be active" check, which reads as a bug in the form
 * rather than as bad sample data.
 */
export interface SamplePlantillaPost {
  /** Enough to exercise the items surface without authorizing an implausible headcount. */
  initialSlots: string;
}

/*
  No code any more: the plantilla id is {PositionCode}-{YY}{NNN} and the server assigns it
  inside the write, so there is nothing here to generate — a value this module invented would
  be discarded, and showing it would claim the post will be called something it will not.
*/
export function samplePlantillaPost(): SamplePlantillaPost {
  return {
    initialSlots: String(1 + Math.floor(Math.random() * 3)),
  };
}
